import { render } from "./onlyOrdersComponent.vue?vue&type=template&id=bb586b7a"
import script from "./onlyOrdersComponent.vue?vue&type=script&lang=js"
export * from "./onlyOrdersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__